// AB   ZIP-005
// Featured Collection - A/B Test Variant
// Progressive enhancement; Swiper initialization for mobile only

document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('[data-section-type="featured-collection"]');
  
  sections.forEach(section => {
    let swiperInstance = null;
    const swiperContainer = section.querySelector('[data-featured-collection-swiper]');
    
    if (!swiperContainer) return;
    
    // Initialize Swiper only on mobile
    function initSwiper() {
      if (window.innerWidth < 750 && !swiperInstance) {
        // Swiper should be available from swiper-bundle.min.js
        if (typeof Swiper !== 'undefined') {
          swiperInstance = new Swiper(swiperContainer, {
            slidesPerView: 2.25,
            spaceBetween: 8,
            loop: true,
            speed: 400,
            watchOverflow: true,
            grabCursor: true,
            resistance: true,
            resistanceRatio: 0.85,
            init: true
          });
        }
      }
    }
    
    // Destroy Swiper on desktop
    function destroySwiper() {
      if (window.innerWidth >= 750 && swiperInstance) {
        swiperInstance.destroy(true, true);
        swiperInstance = null;
      }
    }
    
    // Handle responsive behavior
    function handleResize() {
      if (window.innerWidth < 750) {
        initSwiper();
      } else {
        destroySwiper();
      }
    }
    
    // Initialize on load
    handleResize();
    
    // Handle window resize with debounce
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(handleResize, 150);
    });
  });
});
